const ICON_CHAT = ({ color = "#000", strokeWidth = 3, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 50 50"
    fill="none"
    {...props}
  >
    <path
      className="path_svg"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={strokeWidth}
      d="M17.974 8.506a8.644 8.644 0 0 0-8.662 8.664v8.663c0 4.8 3.863 8.662 8.662 8.662h.846v7l9.218-7h3.987c4.799 0 8.663-3.863 8.663-8.662V17.17c0-4.8-3.864-8.664-8.663-8.664z"
      style={{
        strokeWidth: 3,
        strokeDasharray: "none",
      }}
    />
    <circle
      className="path_svg"
      cx={34.075}
      cy={21.191}
      r={1.48}
      fill="none"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinejoin="bevel"
    />
    <circle
      className="path_svg"
      cx={25}
      cy={21.191}
      r={1.48}
      fill="none"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinejoin="bevel"
    />
    <circle
      className="path_svg"
      cx={15.925}
      cy={21.191}
      r={1.48}
      fill="none"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinejoin="bevel"
    />
  </svg>
);

export default ICON_CHAT;
